<template>
  <div>
    <div class="wrapper" :style="transparentStyle" :class="searchBarFixed == true ? 'isFixed' :''">
      <div class="header-container container cleafix">
        <div class="brand">
          <img class="img-fluid" :src="imgUrl">
        </div>
        <div class="float-right">
          <ul class="nav nav-inline">
            <li
              v-for="(item,index) in items"
              @click="toAct(index)"
              :key="index"
              
            >
              <a
                :href="item.path"
                @click="toSecond(index)"
                v-if="item.title != '协会管理系统'&&item.title!='操作手册'&&item.title!='费用说明'"
                
              >{{item.title}}</a>
              <a
                v-if="item.title == '操作手册'"
                
                @click="toDownload(item.path)"
                
              >{{item.title}}</a>
              <a
                v-if="item.title == '费用说明'"
                :style="colorStyle"
                @click="toExpense(index)"
                :class="{active:index==isActive}"
                class="expense"
              >{{item.title}}</a>
              <a
                href="#"
                v-if="item.title == '协会管理系统'"
                @click="association(item.path)"
                
              >{{item.title}}</a>
              <!--<router-link :to="{path:item.path}">{{item.title}}</router-link>-->
            </li>
          </ul>
          <div class="tel text-main border border-main">
            {{tel}}
            <i class="icon-font">&#xe620;</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "../../../../assets/images/logo_gejuyun.png";

export default {
  name: "ExpHeader",
  props: {
    items: ""
  },
  data() {
    return {
      tel: "020-37579981",
      actId: 6,
      isActive: -1,
      searchBarFixed: false,
      transparentStyle: {
        background: "rgba(255, 255, 255, .001)"
      },
      colorStyle: {
        color: "#0099cc",
        fontWeight: '600'
      },
      imgUrl: logo
    };
  },
  methods: {
    toAct: function(index) {
      this.actId = index;
      //               平滑滚动  导航有多少个就要添加多少个d_jump，根据数组下边判断
      let jump = document.querySelectorAll(".d_jump");
      //    console.log(jump);
      // 获取需要滚动的距离
      let total = jump[index].offsetTop;
      //                console.log(total);
      let step = total / 50 - 3.3;
      // console.log(step)
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      document.body.scrollTop = total;
      document.documentElement.scrollTop = total;
      window.pageYOffset = total;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      //    向下滚动
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }

      //    向上滚动
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
    association: function(e) {
      window.open(e);
    },
    handleScroll() {
      this.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scroll > 88) {
        //124
        // this.postFile= 'orientation'

        this.transparentStyle = {
          background: "#fff"
        };
        
        this.searchBarFixed = true;
        this.imgUrl = logo2;
      } else {
        this.transparentStyle = {
          background: "rgba(255, 255, 255, .001)"
        };
        this.imgUrl = logo2;
        this.searchBarFixed = false;
      }
    },
    toDownload() {
      this.$router.push({
        path: "/download"
      });
    },
    toExpense(index) {
      this.$router.push({
        path: "/expense"
      });
      this.isActive = index;
    },
    toSecond() {
      this.$router.push({
        path: '/home'
      })
    }
  },
  mounted: function() {
    this.actId = 0;
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {},
  activated() {
    window.addEventListener("scroll", this.handleScroll);
  },
  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="css" scoped>
.wrapper {
  position: fixed;
  z-index: 999;
  top:0;
  box-shadow: 0px 15px 10px -20px #000;
}
.isFixed {
  position: fixed;
  width: 100%;
  background-color: #fff;
  top: 0;
  z-index: 999;
  box-shadow: 0px 15px 10px -20px #000;
}
.wrapper {
  width: 100%;
  padding: 16.5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0);
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  width: 207px;
}

.brand .img-fluid {
  width: 100%;
  height: 55px;
}

.float-right {
  display: flex;
  align-items: center;
  padding-left: 240px;
}

.nav {
  float: left;
  display: flex;
  align-items: center;
}

.nav li {
  color: #666;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 0 15px;
}

.nav li a {
  color:#666;
  font-weight: normal;
}

.nav li a.active {
  color:#0099cc;
  font-weight: 600;
}
a.expense{
  color:#0099cc;
  font-weight: 600;
}
.nav li.active a {
  color: #0099cc;
  font-weight: 600 !important;
}

.nav li div,
.nav li div {
  padding: 5px 20px;
  line-height: 20px;
  cursor: pointer;
}

.nav li.active div,
.nav li div:hover {
  color: #0099cc;
  font-weight: normal;
}

.tel {
  float: right;
  font-size: 20px;
  line-height: 32px;
  border-radius: 17px;
  margin-top: 0;
  padding: 0 10px;
  color: #3399ff;
}

.tel > i {
  font-size: 28px;
  margin-left: 6px;
}

.router-link-active {
  color: #0099cc;
  font-weight: normal;
}

.active1 > li:nth-child(1) > a {
  color: #0099cc;
  font-weight: normal;
}

.router-link-active {
  color: #0099cc;
  font-weight: normal;
}
a.link-active{
  color: #0099cc;
  font-weight: 600
}
.active {
  color: #0099cc !important;
  font-weight: normal;
}

.nav-inline li a {
  cursor: pointer;
}
</style>